module.exports = __webpack_public_path__ + "img/nav-design-growing@2x.231d76a.jpg";